import {
	Component,
	ViewEncapsulation,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core";
import {
	DisplayGrid,
	GridType,
	GridsterItemComponent,
	GridsterComponent,
	GridsterConfig,
	GridsterItemComponentInterface,
	GridsterItem,
} from "angular-gridster2";
import {
	DashboardWidget,
	DashboardWidgetFactory,
} from "../shared/models/widget/widget.model";
import { WidgetService } from "../shared/services/widget/widget.service";

//Signal
import { isEditMode } from "../shared/signals/edit-mode";

@Component({
	selector: "app-new-dashboard",
	templateUrl: "./new-dashboard.component.html",
	styleUrls: ["./new-dashboard.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
	encapsulation: ViewEncapsulation.None,
})
export class NewDashboardComponent implements OnInit {
	options: GridsterConfig;
	dashboard: Array<DashboardWidget>;

	widgetList: Array<any>;

	isEditMode = isEditMode;

	constructor(
		private dashboardWidgetFactory: DashboardWidgetFactory,
		private widgetService: WidgetService
	) {}

	ngOnInit() {
		this.options = {
			draggable: {
				delayStart: 0,
				enabled: false,
				ignoreContentClass: "gridster-item-content",
				ignoreContent: false,
				dragHandleClass: "drag-handler",
				dropOverItems: false,
			},
			emptyCellDragCallback: this.emptyCellClick.bind(this),
			emptyCellDropCallback: this.emptyCellClick.bind(this),
			pushItems: false,
			resizable: {
				enabled: false,
			},
			gridType: GridType.Fit,
			displayGrid: DisplayGrid.None,
			outerMargin: false,
			enableBoundaryControl: true,
			disableScrollHorizontal: true,
			enableEmptyCellDrop: true,
			minCols: 12,
			maxCols: 12,
			minRows: 10,
			maxRows: 10,
			maxItemCols: 12,
			minItemCols: 1,
			maxItemRows: 10,
			minItemRows: 1,
			maxItemArea: 60,
			minItemArea: 1,
			defaultItemCols: 1,
			defaultItemRows: 1,
		};

		this.dashboard = [];
		this.dashboard.push(
			this.dashboardWidgetFactory.createWidget(
				"simple",
				undefined,
				undefined,
				{
					icon: "building",
					text: "Properties",
					value: 5,
				}
			)
		);

		this.dashboard.push(
			this.dashboardWidgetFactory.createWidget(
				"simple",
				undefined,
				undefined,
				{
					type: "user",
				}
			)
		);

		this.dashboard.push(this.dashboardWidgetFactory.createWidget("table"));

		this.dashboard.push(this.dashboardWidgetFactory.createWidget("table"));

		this.widgetList = [];
		console.log(this.widgetService.getWidgets());
	}

	removeItem(item: DashboardWidget) {
		this.dashboard.splice(this.dashboard.indexOf(item), 1);
	}

	changedOptions() {
		if (this.options.api && this.options.api.optionsChanged) {
			this.options.api.optionsChanged();
		}
	}

	toggleDragable() {
		isEditMode.set(this.options.draggable!.enabled || false);
		this.changedOptions();
	}

	emptyCellClick(event: MouseEvent | DragEvent, item: GridsterItem) {
		console.log(event, item);

		if (event instanceof DragEvent) {
			let dataStr = event.dataTransfer?.getData("text");
			if (dataStr) {
				let data = JSON.parse(dataStr);

				this.dashboard.push(
					this.dashboardWidgetFactory.createWidget(
						data.type,
						item.x,
						item.y
					)
				);
			}
		}
	}

	dragStartHandler(ev: DragEvent, item: any): void {
		if (ev.dataTransfer) {
			this.options.defaultItemCols = item.cols;
			this.options.defaultItemRows = item.rows;
			this.changedOptions();

			ev.dataTransfer.setData("text/plain", JSON.stringify(item));
			ev.dataTransfer.dropEffect = "copy";
		}
	}
}
